import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAuth } from "../../contexts/auth/Context";
import {
  NOTIFICATIONS_QUERY_KEY,
  NOTIFICATION_UNREAD_COUNT_QUERY_KEY,
  PLATFORM_NOTIFICATIONS_QUERY_KEY,
  PLATFORM_NOTIFICATION_UNREAD_COUNT_QUERY_KEY,
} from "../../query/keys";
import { markAsReadRequest } from "../requests/notification/notification";
import { markPlatformAsReadRequest } from "../requests/notification/platformNotification";
import { isSuperAdminRole } from "../../contexts/auth/utils";

export const useMarkAsRead = () => {
  const { token } = useAuth();
  const queryClient = useQueryClient();
  const isPlatform = isSuperAdminRole(token);

  return useMutation({
    mutationFn: (publicId: string) =>
      isPlatform
        ? markPlatformAsReadRequest(token!, publicId)
        : markAsReadRequest(token!, publicId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: isPlatform
          ? PLATFORM_NOTIFICATIONS_QUERY_KEY
          : NOTIFICATIONS_QUERY_KEY,
      });
      queryClient.invalidateQueries({
        queryKey: isPlatform
          ? PLATFORM_NOTIFICATION_UNREAD_COUNT_QUERY_KEY
          : NOTIFICATION_UNREAD_COUNT_QUERY_KEY,
      });
    },
  });
};
